import "@awesome.me/webawesome/dist/components/details/details.js";
import { startFuxiAssembly } from "./fuxi-assembly.js";
import { startLianxi } from "./lianxi-start.js";
import { startPinzi } from "./lianxi-pinzi-start.js";
import { startShuoci } from "./lianxi-shuoci-start.js";
import { startYufa } from "./lianxi-yufa-start.js";
import "@awesome.me/webawesome/dist/components/popover/popover.js";
import "@awesome.me/webawesome/dist/components/radio-group/radio-group.js";
import "@awesome.me/webawesome/dist/components/button/button.js";

/**
 * The script an Exercise 练习 page loads.
 *
 * A bundle of its own, on the argument `main-bishun.ts` makes for the entry
 * page: the drills are drawn on the `/lianxi/xiezi/` pages and the grammar
 * exercises on the `/lianxi/yufa/` pages, and nowhere else, and the strokes
 * and the tiles are more than the copy buttons are. It shares nearly all of
 * its drill code with the entry page's bundle, and a reader who opens both
 * pays for the overlap twice, which is the right way round for pages most
 * readers see one of.
 *
 * `partials/lianxi/drill.html`, `partials/lianxi/yufa.html` and
 * `partials/lianxi/pinzi.html` are what load it. The reading Exercise is on
 * its passage's page, and `./main-yuedu.ts` starts it. A 拼字 Exercise chooses its parts with the script a 复习 card does
 * (`./fuxi-assembly.ts`), which finds nothing on any other page. The tag is `type="module"`, which defers, so the block has been parsed
 * by the time this runs. Each starter finds its own blocks, and a page holds
 * one kind.
 */
startLianxi(document);
startYufa(document);
startFuxiAssembly(document);
startPinzi(document);
startShuoci(document);
